import { render } from "./mls-disclaimer-v2.vue?vue&type=template&id=3946f94c"
import script from "./mls-disclaimer-v2.vue?vue&type=script&lang=js"
export * from "./mls-disclaimer-v2.vue?vue&type=script&lang=js"

import "./mls-disclaimer-v2.vue?vue&type=style&index=0&id=3946f94c&lang=scss"

import exportComponent from "/builds/feng.chen/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__